export const getEvenDaysDiff = (d: Date) => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    d.setHours(0, 0, 0, 0);
    return Math.round((now.getTime() - d.getTime()) / 8.64e7);
}
